export const getUsernameFromURL = () => {
  const hostname = window.location.hostname;
  const username = hostname.split(".")[0];
  return username;
};

export function beginsWithVowel(string) {
  return /^[aeiouAEIOU]/.test(string);
}
